import { render, staticRenderFns } from "./OrphanView.vue?vue&type=template&id=c1fb48c2&"
import script from "./OrphanView.vue?vue&type=script&lang=js&"
export * from "./OrphanView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports